import classnames from 'classnames';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';
import WistiaVideoPlayer from 'molecules/Video';

import styles from 'components/Heros/PageHeaderHero/page-header.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { PageHeaderHeroProps } from 'components/Heros/PageHeaderHero/config';
import type { FC } from 'react';

const PageHeaderHero: FC<PageHeaderHeroProps> = ({
  eyebrow,
  contents,
  borderBottomImage,
  backgroundColor,
  removePadding,
  subhead,
}) => {
  // Extract string value from localized object
  const eyebrowText =
    typeof eyebrow === 'object' && eyebrow !== null
      ? (eyebrow as any).Default || (eyebrow as any).default || ''
      : eyebrow || '';

  const onlyEyebrow = Boolean(eyebrow && !subhead);

  return (
    <>
      <section
        className={classnames(styles.pageHeaderWrapper, {
          [styles.bkGray]: backgroundColor === 'grey',
          [styles.bkWhite]: backgroundColor === 'white',
          [styles.removePadding]: removePadding === true,
        })}
      >
        <div className={styles.pageHeaderContainer}>
          <div className={styles.pageHeaderInner}>
            {onlyEyebrow ? (
              <h1 className={styles.pageHeaderTitle}>{eyebrowText}</h1>
            ) : (
              <h2 className={styles.pageHeaderTitle}>{eyebrowText}</h2>
            )}
            {subhead && <h1 className={styles.pageHeaderSubhead}>{subhead}</h1>}
            {isNonEmptyArray(contents) &&
              contents.map(({ body, ctas, embed }, index) => (
                <div key={index} className={styles.content}>
                  {body && (
                    <RichText
                      className={styles.pageHeaderBodyTextWrapper}
                      content={body
                        .replace(/\\n/g, '\n')
                        .replace(/\\ul/g, '<ul>')
                        .replace(/\\cul/g, '</ul>')
                        .replace(/\\b/g, `<div class="${styles.secondary_eyebrow}">`)
                        .replace(/\\cb/g, '</div>')
                        .replace(/\\h5/g, `<div class="${styles.heading5}">`)
                        .replace(/\\ch5/g, '</div>')}
                    />
                  )}
                  {isNonEmptyArray(ctas) &&
                    ctas.map(
                      (cta, index1) =>
                        cta?.label &&
                        cta?.link &&
                        (cta.type === 'arrow' ? (
                          <Button
                            key={index1}
                            className={`${styles.arrowLink} ${cta.removeBottomMargin ? styles.removeBottomMargin : ''}`}
                            direction="right"
                            url={cta.link}
                            iconId="arrow-right"
                          >
                            {cta.label}
                          </Button>
                        ) : (
                          <Button
                            key={index}
                            url={cta.link}
                            color="teal"
                            label={cta?.label}
                            className={styles.marginRight}
                          />
                        )),
                    )}
                  {embed && <WistiaVideoPlayer embed={embed} />}
                </div>
              ))}
          </div>
        </div>
      </section>
      {borderBottomImage?.url && (
        <div className={styles.pageHeaderBorder}>
          <Image
            url={borderBottomImage?.url}
            width={1920}
            height={30}
            alt="Background Image for Page Header"
            sizes="100vw"
            quality={100}
            className={styles.borderImage}
            priority
          />
        </div>
      )}
    </>
  );
};

export default PageHeaderHero;
